/* -------------------------------------------------------------------------- */
/*                                Side menu item styles                */
/* -------------------------------------------------------------------------- */

@import './bq-side-menu-item.variables';

:host {
  @apply flex;
}

.bq-side-menu__item {
  @apply flex flex-grow items-center gap-x-s rounded-s border-none px-[var(--bq-side-menu-item--paddingX)] py-[var(--bq-side-menu-item--paddingY)] no-underline transition-colors duration-150;

  // Default state
  @apply bg-[var(--bq-side-menu-item--bg-default)] text-m text-[color:var(--bq-side-menu-item--text-default)];

  // Focus state
  @apply [&:not(.disabled)]:focus-visible:focus;

  // Hover state
  @apply [&:not(.disabled)]:hover:cursor-pointer;
  @apply [&:not(.disabled,.active)]:hover:text-m [&:not(.disabled,.active)]:hover:bg-hover-ui-alt [&:not(.disabled,.active)]:hover:text-hover-primary;
}

.bq-side-menu__item.active {
  // Active state
  @apply bg-[var(--bq-side-menu-item--bg-active)] text-m text-[color:var(--bq-side-menu-item--text-active)];
}

.bq-side-menu__item.disabled {
  @apply opacity-60 hover:cursor-not-allowed;
}

.bq-side-menu__item.is-collapsed {
  @apply justify-center gap-0;

  .bq-side-menu__item--label,
  .bq-side-menu__item--suffix {
    @apply sr-only scale-0;
  }
}

.bq-side-menu__item--label,
.bq-side-menu__item--suffix {
  @apply transition-all duration-300 ease-in-out;
}
